import { msalInstance } from "./auth-config";

const logout = async () => {
  try {
    await msalInstance.logoutRedirect();
  } catch (e) {}
};

export default logout;
